<template>
    <section class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">

                    <div class="card" v-if="$gate.isAdmin()">
                        <div class="card-header">
                            <h3 class="card-title">Lista de usuários</h3>

                            <div class="card-tools">

                                <button type="button" class="btn btn-sm btn-primary" @click="newModal">
                                    <i class="fa fa-plus-square"></i>
                                    Adicione novo
                                </button>
                            </div>
                        </div>
                        <!-- /.card-header -->
                        <div class="card-body table-responsive p-0">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Tipo</th>
                                        <th>Nome</th>
                                        <th>Email</th>
                                        <th>Email Verificado?</th>
                                        <th>Data Liberação</th>
                                        <th>Status</th>
                                        <th>Criado em</th>
                                        <th>Ação</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="user in users.data" :key="user.id">

                                        <td>{{ user.id }}</td>
                                        <td class="text-capitalize">{{ user.type }}</td>
                                        <td class="text-capitalize">{{ user.name }}</td>
                                        <td>{{ user.email }}</td>
                                        <td :inner-html.prop="user.email_verified_at | yesno"></td>
                                        <td>{{ user.login_release_date | formatDate }}</td>
                                        <td>
                                            <span v-if="isUserExpired(user)" class="badge badge-danger">Expirado</span>
                                            <span v-else-if="user.login_blocked"
                                                class="badge badge-warning">Bloqueado</span>
                                            <span v-else class="badge badge-success">Ativo</span>
                                        </td>
                                        <td>{{ user.created_at }}</td>

                                        <td>

                                            <a href="#" @click="editModal(user)">
                                                <i class="fa fa-edit blue"></i>
                                            </a>
                                            /
                                            <a href="#" @click="deleteUser(user.id)">
                                                <i class="fa fa-trash red"></i>
                                            </a>
                                            /
                                            <a href="#" @click="manageAccess(user)" title="Gerenciar acesso">
                                                <i class="fa fa-calendar-alt"></i>
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <!-- /.card-body -->
                        <div class="card-footer">
                            <pagination :data="users" @pagination-change-page="getResults"></pagination>
                        </div>
                    </div>
                    <!-- /.card -->
                </div>
            </div>


            <div v-if="!$gate.isAdmin()">
                <not-found></not-found>
            </div>

            <!-- Modal -->
            <div class="modal fade" id="addNew" tabindex="-1" role="dialog" aria-labelledby="addNew" aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" v-show="!editmode">Crie novo usuário</h5>
                            <h5 class="modal-title" v-show="editmode">Atualize as informações do usuário</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>

                        <!-- <form @submit.prevent="createUser"> -->

                        <form @submit.prevent="editmode ? updateUser() : createUser()">
                            <div class="modal-body">
                                <div class="form-group">
                                    <label>Nome</label>
                                    <input v-model="form.name" type="text" name="name" class="form-control"
                                        :class="{ 'is-invalid': form.errors.has('name') }">
                                    <has-error :form="form" field="name"></has-error>
                                </div>
                                <div class="form-group">
                                    <label>Email</label>
                                    <input v-model="form.email" type="text" name="email" class="form-control"
                                        :class="{ 'is-invalid': form.errors.has('email') }">
                                    <has-error :form="form" field="email"></has-error>
                                </div>

                                <div class="form-group">
                                    <label>Senha</label>
                                    <input v-model="form.password" type="password" name="password" class="form-control"
                                        :class="{ 'is-invalid': form.errors.has('password') }" autocomplete="false">
                                    <has-error :form="form" field="password"></has-error>
                                </div>

                                <div class="form-group">
                                    <label>Função de usuário</label>
                                    <select name="type" v-model="form.type" id="type" class="form-control"
                                        :class="{ 'is-invalid': form.errors.has('type') }">
                                        <option value="">Selecione a função do usuário</option>
                                        <option value="admin">Admin</option>
                                        <option value="user">Usuário padrão</option>
                                    </select>
                                    <has-error :form="form" field="type"></has-error>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                                <button v-show="editmode" type="submit" class="btn btn-success">Atualizar</button>
                                <button v-show="!editmode" type="submit" class="btn btn-primary">Criar</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <!-- Modal -->
            <div class="modal fade" id="accessModal" tabindex="-1" role="dialog" aria-labelledby="accessModalLabel"
                aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Gerenciar Acesso</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <form @submit.prevent="updateAccess">
                            <div class="modal-body">
                                <div class="form-group">
                                    <label>Usuário</label>
                                    <input type="text" class="form-control" :value="accessForm.name" readonly>
                                </div>
                                <div class="form-group">
                                    <label>Data de Liberação</label>
                                    <input v-model="accessForm.login_release_date" type="date" class="form-control">
                                </div>
                                <div class="form-group">
                                    <div class="form-check">
                                        <input v-model="accessForm.login_blocked" type="checkbox"
                                            class="form-check-input" id="blockUser">
                                        <label class="form-check-label" for="blockUser">Bloquear acesso</label>
                                    </div>
                                </div>
                                <div class="alert alert-info" v-if="isUserExpired(accessForm)">
                                    Acesso expirado em {{ getExpiryDate(accessForm) | formatDate }}
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                                <button type="submit" class="btn btn-primary">Salvar</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    data() {
        return {
            editmode: false,
            users: {},
            form: new Form({
                id: '',
                type: '',
                name: '',
                email: '',
                password: '',
                email_verified_at: '',
            }),
            accessForm: new Form({
                id: '',
                name: '',
                login_release_date: '',
                login_blocked: false
            })
        }
    },
    methods: {

        getResults(page = 1) {

            this.$Progress.start();

            axios.get('api/user?page=' + page).then(({ data }) => (this.users = data.data));

            this.$Progress.finish();
        },
        updateUser() {
            this.$Progress.start();
            // console.log('Editing data');
            this.form.put('api/user/' + this.form.id)
                .then((response) => {
                    // success
                    $('#addNew').modal('hide');
                    Toast.fire({
                        icon: 'success',
                        title: response.data.message
                    });
                    this.$Progress.finish();
                    //  Fire.$emit('AfterCreate');

                    this.loadUsers();
                })
                .catch(() => {
                    this.$Progress.fail();
                });

        },
        editModal(user) {
            console.log(user);
            this.editmode = true;
            this.form.reset();
            $('#addNew').modal('show');
            this.form.fill(user);
        },
        newModal() {
            this.editmode = false;
            this.form.reset();
            $('#addNew').modal('show');
        },
        deleteUser(id) {
            Swal.fire({
                title: 'Tem certeza?',
                text: "Você não será capaz de reverter isso!",
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Sim, exclua!'
            }).then((result) => {

                // Send request to the server
                if (result.value) {
                    this.form.delete('api/user/' + id).then(() => {
                        Swal.fire(
                            'Excluído!',
                            'Seu arquivo foi excluído.',
                            'success'
                        );
                        // Fire.$emit('AfterCreate');
                        this.loadUsers();
                    }).catch((data) => {
                        Swal.fire("Falha!", data.message, "warning");
                    });
                }
            })
        },


        createUser() {

            this.form.post('api/user')
                .then((response) => {
                    $('#addNew').modal('hide');

                    Toast.fire({
                        icon: 'success',
                        title: response.data.message
                    });

                    this.$Progress.finish();
                    this.loadUsers();

                })
                .catch(() => {

                    Toast.fire({
                        icon: 'error',
                        title: 'Algum erro ocorreu!Por favor, tente novamente'
                    });
                })
        },
        isUserExpired(user) {
            if (!user.login_release_date) return true;

            const releaseDate = new Date(user.login_release_date);
            const expiryDate = new Date(releaseDate);
            expiryDate.setMonth(expiryDate.getMonth() + 12);

            return new Date() > expiryDate;
        },

        getExpiryDate(user) {
            if (!user.login_release_date) return null;

            const releaseDate = new Date(user.login_release_date);
            const expiryDate = new Date(releaseDate);
            expiryDate.setMonth(expiryDate.getMonth() + 12);

            return expiryDate;
        },

        manageAccess(user) {
            this.accessForm.reset();
            this.accessForm.fill(user);
            $('#accessModal').modal('show');
        },

        updateAccess() {
            this.accessForm.put('api/user/' + this.accessForm.id)
                .then((response) => {
                    $('#accessModal').modal('hide');
                    Toast.fire({
                        icon: 'success',
                        title: 'Acesso atualizado com sucesso!'
                    });
                    this.loadUsers();
                })
                .catch(() => {
                    Toast.fire({
                        icon: 'error',
                        title: 'Ocorreu um erro ao atualizar o acesso!'
                    });
                });
        },

        // Modifique o loadUsers para garantir que traz os novos campos
        loadUsers() {
            this.$Progress.start();
            if (this.$gate.isAdmin()) {
                axios.get("api/user?include=access").then(({ data }) => (this.users = data.data));
            }
            this.$Progress.finish();
        }

    },
    filters: {
        formatDate(value) {
            if (!value) return 'Nunca';
            const date = new Date(value);
            return date.toLocaleDateString('pt-BR');
        }
    },
    mounted() {
        console.log('Componente do usuário montado.')
    },
    created() {

        this.$Progress.start();
        this.loadUsers();
        this.$Progress.finish();
    }
}
</script>
<style>
.text-danger {
    color: #dc3545 !important;
    font-weight: bold;
}

.badge-expired {
    background-color: #dc3545;
    color: white;
}
</style>